import React from 'react';
import { connect } from "react-redux";
import { BsBackspaceFill } from 'react-icons/bs'
import { store } from 'react-notifications-component';
import updateItem from '../../../../API/Provider/CreateExchangeRate.js'
import Loader from './../../../../Global/loader'
import { withNamespaces } from 'react-i18next';
import DatePicker from 'react-datepicker'
import "react-datepicker/dist/react-datepicker.css";
import './datepicker.scss'
import hr from 'date-fns/locale/hr';
import { Button, Row, Col, Form } from "react-bootstrap";
//import GetAutomatic from './../../../../API/Provider/GetAutomatic'
//import Select from 'react-select'

class UpdateTecajnaLista extends React.Component {
    constructor(props) {
        super(props); 
        this.submitUpdate = this.submitUpdate.bind(this);
    }

    state={
        loading: false   
    }

    componentDidMount = async () => {
        this.setState({ loading: true})

        // await this.setState({
        //     automaticList: [],
        //     automaticPicked: {}
        // })
        // //get countries
        // let items = await GetAutomatic()       
        // let list = []
        // let pickedAuto = {}

        // await items.data.map((data, index) =>{
        //     let oneItem = {value: index , label: data }
        //     list.push(oneItem)
        //     console.log(data)
        //     console.log(this.props.oneExchangeRate.currency_short)
        //     if(data === this.props.oneExchangeRate.currency_short){
        //         console.log(data)
        //         pickedAuto = oneItem;
        //     }
                
        //     return null
        // })

        this.setState({ 
            loading: false
        })
    }


    handleChange = async (e) => {
        await this.props.mapState("CHANGE_ONE_EXCHANGE_RATE", e.target) 
    }

    handleDateChange = async (e) => {
        let data = {
            value: e,
            id: "date_of_exchange_rate"
        }
        await this.props.mapState("CHANGE_ONE_EXCHANGE_RATE", data) 
    }

    submitUpdate = async (e) =>{
        const { t } = this.props

        e.preventDefault()
        
        let update = await updateItem(
            this.props.oneExchangeRate
        )
        
        if(update.data.status === 200){
            store.addNotification({
                title: t('Success!'),
                message: t('The Exchange rate has been changed'),
                type: "success",
                insert: "top",
                container: "top-right",
                animationIn: ["animate__animated", "animate__fadeIn"],
                animationOut: ["animate__animated", "animate__fadeOut"],
                dismiss: {
                  duration: 5000,
                  pauseOnHover: true
                }
            });
        }
        else(
            store.addNotification({
                title: t('Error!'),
                message: t("An error occurred while changing the client type, please try again."),
                type: "danger",
                insert: "top",
                container: "top-right",
                animationIn: ["animate__animated", "animate__fadeIn"],
                animationOut: ["animate__animated", "animate__fadeOut"],
                dismiss: {
                  duration: 5000,
                  onScreen: true
                }
            })
        )
        
        this.props.goBack()
    }

    render(){  
        const { t } = this.props

        return (
            <div>
                {this.state.loading ?
                    <Loader />
                :
                <Form className="form-container">
                    <Row>        
                        <Col sm={12} lg={6} xl={4}>
                           <Form.Group as={Row} className="mb-3">
                                <Form.Label htmlFor="country" column sm={2} md={4}>{t('Date')}</Form.Label>
                                <Col sm={10} md={8}>
                                    <DatePicker
                                        selected={new Date(this.props.oneExchangeRate.date_of_exchange_rate)}
                                        onChange={date => this.handleDateChange(date)}
                                        startDate={new Date()}
                                        locale={this.props.lng === "hr" ? hr : null}
                                        dateFormat="dd.MM.yyyy"
                                        maxDate={new Date()}
                                    />                                 
                                </Col>
                            </Form.Group>
                            <Form.Group as={Row} className="mb-3">
                                <Form.Label htmlFor="currency_name" column sm={2} md={4}>{t('Name')}</Form.Label>
                                <Col sm={10} md={8}>
                                   <Form.Control        
                                            id="currency_name"                          
                                            type="text"
                                            value={this.props.oneExchangeRate.currency_name}
                                            onChange={e => this.handleChange(e)}
                                        />
                                </Col>
                            </Form.Group>

                            <Form.Group as={Row} className="mb-3">
                                <Form.Label htmlFor="exchange_rate" column sm={2} md={4}>{t('Exchange Rate')}</Form.Label>
                                <Col sm={10} md={8}>
                                   <Form.Control        
                                        id="exchange_rate"                          
                                        type="number"
                                        value={this.props.oneExchangeRate.exchange_rate}
                                        onChange={e => this.handleChange(e)}
                                        min={0}
                                    />   
                                </Col>
                            </Form.Group>

                            <Form.Group as={Row} className="mb-3">
                                <Col sm={12} className="text-center">
                                    <Button                                     
                                        className="btnSpremi"
                                        onClick={(e) => this.submitUpdate(e)}
                                    >
                                        {t('Save')}
                                    </Button>
                                </Col> 
                            </Form.Group>
                        </Col>
                    </Row>           
                    
                    <Row className="back-button-container">
                        <Button 
                            variant='default'
                            className="btn-default mt-2 mb-2"
                            onClick={() => this.props.goBack()}
                        >
                            <BsBackspaceFill size={30} />  <strong>{t('Back')}</strong>
                        </Button>
                    </Row>
                </Form>
              
                }     
            </div>

        )
    }
}
const mapStateToProps = state => {
    return {
        oneExchangeRate: state.codeBook.oneExchangeRate
    };
};
  
const mapDispatchToProps = dispatch => {
    return {
        mapState: (type, data) => dispatch({ type: type, data: data}),
        API: (type, data) => dispatch({ type: type, data: data})
    };
};
  
export default connect(
    mapStateToProps,
    mapDispatchToProps
)(withNamespaces()(UpdateTecajnaLista));


